module.exports = __webpack_public_path__ + "static/img/capstructure.37eb047.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/capstructure.png
// module id = NAmq
// module chunks = 1